<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="ded" id="ack"><a id="page_6">ACKNOWLEDGMENTS</a></p><a id="page_6">
<p class="ded">A great big THANK-YOU must go to Pistol Pete Cormican, premier DJ of Dallas, Texas, and one of the most open and generous men with whom it was ever my pleasure to speak.</p>
<p class="ded">By telephone he helped me through the geography of his fine city, leading me through the maze of streets and suburbs with patience and ease.</p>
<p class="ded">Any physical discrepancies you might find in various locations are nothing more than creative license, and any mistakes are mine, not his.</p>
</a></div><a id="page_6">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?f1dd21f0